export default {
  getUser: state => {
    return state.user;
  },
  getScale: state => {
    return state.scale;
  },
  getScreenSize: state => {
    return state.scale;
  },
  getEducationResults: state => {
    return state.educationResults;
  },

  getPendingReviews: state => {
    return state.pendingReviews;
  },
};
